//convert timeStr to today datetime object
// timeStr supported are "hh:mm am|pm" or "hh am|pm"
export function parseTodayTime(timeStr){
    const now = new Date();
    const dateStr = now.toLocaleDateString();
    if(!timeStr.includes(":")) { timeStr = timeStr.replace(" ", ":00 ") };
    return Date.parse(dateStr+ " "+timeStr);
}
